// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1peUs","colCheckbox":"styles_colCheckbox__1oFfh"};